export default "__VITE_ASSET__BrF4kSEw__"